import { ReactComponent as FloorPlanIcon } from '../../assets/icons/mdi_floor-plan.svg'
import { ReactComponent as FloorPlanVacancyIcon } from '../../assets/icons/mdi_floor-plan-vacancy.svg'
import { ReactComponent as PercentualIcon } from '../../assets/icons/fontisto_shopping-sale.svg'
import SvgIcon from '@mui/material/SvgIcon';

const icons = {
    floorPlanIcon: FloorPlanIcon,
    floorPlanVacancyIcon: FloorPlanVacancyIcon,
    percentualIcon: PercentualIcon
};

export const Icon = ({icon, width=16, height=width})=>{
    const SpecificIcon = icons[icon];
    return <SvgIcon component={SpecificIcon} inheritViewBox={true} sx={{width, height}}/>
}